import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

const TalentReviewAxisLabelField = styled(Box)<{ vertical?: boolean }>`
	white-space: pre;
	cursor: text;

	svg {
		display: block;
	}

	${(props) =>
		props.vertical &&
		`
		position: absolute;
		left: 50%;
		transform: translateX(-50%) translateY(-50%) rotateZ(-90deg);
		transition: .4s cubic-bezier(0.16, 1, 0.3, 1) transform;
`}
`;

export default function TalentReviewAxisLabel(props: {
	text: graphql.LocalizedString;
	vertical?: boolean;
	/** Wraps the words so a tooltip trigger stays on the label, not the padding around it. */
	wrapText?: (text: string) => ReactNode;
}) {
	const { localize } = useLocalize();
	const { t } = useTranslation();
	const text = localize(props.text)?.text ?? t('talentReviews.v2.label.empty');

	return (
		<TalentReviewAxisLabelField vertical={props.vertical} px={3} py={2}>
			{props.wrapText ? props.wrapText(text) : text}
		</TalentReviewAxisLabelField>
	);
}
